/* Rating display shared by the teacher feedback / ranking pages */
import React from "react";
import { Star } from "lucide-react";
import { CustomBadge } from "../../Component/customComponents";

/** 4.26 → 4.3 (same rounding as the old tables); missing → null */
export const roundRating = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? Math.round((n + Number.EPSILON) * 10) / 10 : null;
};

/** ★ 4.3 — green ≥ 4, amber ≥ 3, red below */
export const RatingBadge = ({ value, size = "sm" }) => {
  const r = roundRating(value);
  if (r === null || r === 0) return "—";
  const tone = r >= 4 ? "success" : r >= 3 ? "warning" : "danger";
  return (
    <CustomBadge tone={tone} size={size} icon={<Star size={12} fill="currentColor" />}>
      {r}
    </CustomBadge>
  );
};
